module.exports = __webpack_public_path__ + "static/media/The-Most-Interesting-Man-In-The-World.598058f2.jpg";